<template>
  <confirmation-dialog ref="dialog" close-on-action>
    <template v-slot:body>
      <div class="a-container-form align-items-baseline">
        <p class="a-label a-width-100-percent">1. Совпадение ФИО</p>
        <label class="a-label" v-if="sameLastName.length">
          {{sameLastName.length}} совпадений
          <router-link class="gui-btn-none-style gui-btn--link"
                       :to="{name: 'catalogs-users-account', params: { userId: userId, tab: 'account'}}"
                       v-for="userId in sameLastName">
            {{user | fullName}}
          </router-link>
        </label>
        <label class="a-label u-red-color" v-else>нет совпадений</label>
      </div>
      <div class="a-container-form">
        <p class="a-label a-label--w-260">2. Контрагенты с тем же полным наименованием</p>
        <label class="a-label" v-if="sameFullName">{{sameFullName}} совпадений</label>
        <label class="a-label u-red-color" v-else>нет совпадений</label>
      </div>
      <div class="a-container-form">
        <p class="a-label a-label--w-260">3. Контрагенты с тем же кратким наименованием</p>
        <label class="a-label" v-if="sameShortName">{{sameShortName}} совпадений</label>
        <label class="a-label u-red-color" v-else>нет совпадений</label>
      </div>
      <div class="a-container-form">
        <p class="a-label a-label--w-260">4. Контрагенты с тем же УНП/ИНН</p>
        <label class="a-label" v-if="sameINN">{{sameINN}} совпадений</label>
        <label class="a-label u-red-color" v-else>нет совпадений</label>
      </div>
      <div class="a-container-form">
        <p class="a-label a-label--w-260">5. Сверка ФИО в ЭЦП и в карточка пользователя</p>
        <label class="a-label" v-if="sameUserInSignature">ФИО соответствует</label>
        <label class="a-label u-red-color" v-else>ФИО отличаются</label>
      </div>
      <div class="a-container-form">
        <p class="a-label a-label--w-260">6. Сверка наименования контрагента и в карточка контрагента</p>
        <label class="a-label" v-if="sameOrganizationInSignature">Контрагент соответствует</label>
        <label class="a-label u-red-color" v-else>Контрагент отличается</label>
      </div>
    </template>
  </confirmation-dialog>
</template>

<script>
  import ConfirmationDialog from "./ConfirmationDialog";
  import Cleave from 'vue-cleave-component'

  export default {
    data: () => ({
      sameLastName: undefined,
      sameFullName: undefined,
      sameShortName: undefined,
      sameINN: undefined,
      sameUserInSignature: undefined,
      sameOrganizationInSignature: undefined,
      user: undefined
    }),

    components: {
      ConfirmationDialog,
      Cleave
    },

    methods: {
      open(user, result) {
        this.user = user;
        this.sameLastName = result.sameLastName || [];
        this.sameFullName = result.sameFullName;
        this.sameShortName = result.sameShortName;
        this.sameINN = result.sameINN;
        this.sameUserInSignature = result.sameUserInSignature;
        this.sameOrganizationInSignature = result.sameOrganizationInSignature;

        this.$refs.dialog.open({
          title: 'Результат проверки'
        });
      }
    }
  }
</script>

<style lang="scss" scoped>
  .a-label {
    max-width: 300px;
  }
</style>
